var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Dropdown, Form, Icon, Input, Menu, message, Modal, Select, Spin, Table } from 'antd';
import * as _ from 'lodash';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Fragment } from 'react';
import * as React from 'react';
import { history } from 'src/App';
import ConstantField from 'src/shared/components/ConstantField';
import form from 'src/shared/decorators/form';
import Page from 'src/shared/layout/Page';
import services from 'src/shared/services/services';
import stores from 'src/stores/stores';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.model = [];
        _this.selected = [];
        _this.modal = {
            loading: false,
            basvuru: false,
            basvuruLink: ''
        };
        _this.columns = [];
        _this.filters = [];
        _this.filter = '';
        _this.onBasvuru = function () {
            _this.props.form.validateFields(function (errors, values) {
                if (!errors) {
                    _this.modal.loading = true;
                    services.Company.sendLink(values.email)
                        .then(function (c) {
                        if (c.isNew) {
                            message.success('Email adresi zaten kaydedilmiş. Link tekrar gönderildi..');
                        }
                        else {
                            message.success('Başvuru linki gönderildi..');
                        }
                        _this.modal.basvuru = false;
                        _this.modal.loading = false;
                        var link = location.origin + '/guest/company/' + c.model.email + '/' + c.model.token;
                        Modal.warn({
                            title: 'Aşağıdaki başvuru linki gönderilmiştir.',
                            content: (React.createElement(React.Fragment, null,
                                React.createElement(Input, { value: link }),
                                React.createElement("br", null),
                                React.createElement("a", { href: "javascript:;", onClick: function () { return window.open(link); } }, "Linki A\u00E7")))
                        });
                    })
                        .catch(function () {
                        _this.loading = false;
                    });
                }
            });
        };
        _this.setStatus = function (id, status) {
            services.Company.setStatus(id, status).then(function () {
                message.success('Durum güncellendi!');
                _this.refresh();
            });
        };
        _this.refresh = function () {
            _this.loading = true;
            // this.props.form.validateFields();
            services.Company.getAllVM(_this.filters, undefined)
                .then(function (c) {
                _this.model = c;
                _this.loading = false;
            })
                .catch(function () {
                _this.loading = false;
            });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var menu;
            var _this = this;
            return __generator(this, function (_a) {
                this.refresh();
                menu = function (c, row) { return (React.createElement(Dropdown, { overlay: React.createElement(Menu, { onClick: function (e) {
                            if (e.key === 'nihaiRapor') {
                                window.open('/common/company/rapor/' + row.id);
                            }
                            else if (e.key === 'detail') {
                                window.open('/common/company/' + row.id);
                            }
                            else if (e.key === 'basvuruDegerlendir') {
                                window.open('/common/company/' + row.id);
                            }
                            else if (e.key === 'basvuruLinkiniGoster') {
                                _this.loading = true;
                                services.Company.get(row.id).then(function (c) {
                                    Modal.warn({
                                        title: c.name + ' firmasının başvuru linki.',
                                        content: (React.createElement(React.Fragment, null,
                                            React.createElement(Input, { value: location.origin + '/guest/company/' + c.email + '/' + c.token }),
                                            React.createElement("br", null),
                                            React.createElement("a", { href: "javascript:;", onClick: function () { return window.open(location.origin + '/guest/company/' + c.email + '/' + c.token); } }, "Linki A\u00E7")))
                                    });
                                    _this.loading = false;
                                });
                            }
                            else if (e.key === 'tahsisDurumunuDegistir') {
                                Modal.confirm({
                                    title: row.name + ' firmasının tahsis durumu değişimi.',
                                    content: (React.createElement(React.Fragment, null,
                                        React.createElement(ConstantField, { group: "firma.basvuru.tahsis", defaultValue: row.tahsisSonuc, onChange: function (c) {
                                                row.tahsisSonuc = Number(c);
                                            }, style: { width: '100%' } }))),
                                    onOk: function () {
                                        services.Company.setTahsisSonuc(row.id, row.tahsisSonuc).then(function () {
                                            message.success('Tahsis durumu başarıyla değiştirilmiştir!');
                                        });
                                    }
                                });
                            }
                            else if (e.key === 'delete') {
                                _this.delete(row.id);
                            }
                            else if (e.key === 'email') {
                                var email = prompt('Yeni email adresini giriniz..', row.email);
                                if (email) {
                                    services.Company.changeEmail(row.id, email).then(function () { return message.success('Email adresi başarıyla değiştirildi..'); });
                                }
                            }
                            else {
                                _this.setStatus(row.id, e.key);
                            }
                        } },
                        React.createElement(Menu.Item, { key: "detail" }, "Detay"),
                        (stores.auth.hasRole('administrator') || stores.auth.hasRole('yetkili')) &&
                            (row.status === 'Nihai Rapor' || (row.status === 'Değerlendirmede' && row.puanlayanKisiSayisi >= 1)) && (React.createElement(Menu.Item, { key: "nihaiRapor" }, "Nihai Rapor")),
                        stores.auth.hasRole('administrator') ||
                            (stores.auth.hasRole('osb yetkilisi') && row.status === 'Başvuru Onaylandı' && (React.createElement(Menu.Item, { key: "De\u011Ferlendirmede" }, "De\u011Ferlendirmeye G\u00F6nder"))),
                        stores.auth.hasRole('değerlendirici') && row.status === 'Değerlendirmede' && (React.createElement(Menu.Item, { key: "basvuruDegerlendir" }, "Ba\u015Fvuruyu De\u011Ferlendir")),
                        (stores.auth.hasRole('administrator') || stores.auth.hasRole('osb yetkilisi')) && row.status === 'Başvuru Tamamlandı' && (React.createElement(Menu.Item, { key: "Ba\u015Fvuru Onayland\u0131" }, "Ba\u015Fvuruyu Onayla")),
                        row.status === 'Link Gönderildi' && React.createElement(Menu.Item, { key: "basvuruLinkiniGoster" }, "Ba\u015Fvuru Linkini G\u00F6ster"),
                        row.status === 'Nihai Rapor' && React.createElement(Menu.Item, { key: "tahsisDurumunuDegistir" }, "Tahsis Durumunu De\u011Fi\u015Ftir"),
                        !stores.auth.hasRole('osb yetkilisi') && React.createElement(Menu.Item, { key: "email" }, "Email G\u00FCncelleme"),
                        stores.auth.hasRole('administrator') && React.createElement(Menu.Item, { key: "delete" }, "Sil")) },
                    React.createElement(Button, null,
                        "\u0130\u015Flem ",
                        React.createElement(Icon, { type: "down" })))); };
                if (stores.auth.hasRole('osb yetkilisi')) {
                    this.columns = [
                        { dataIndex: 'email', title: 'Email' },
                        { dataIndex: 'basvuruNo', title: 'Başvuru No' },
                        { dataIndex: 'name', title: 'Firma Adı' },
                        { dataIndex: 'createdOn', title: 'İlk Başvuru Tarihi', render: function (c) { return c.format('DD.MM.YYYY'); } },
                        { dataIndex: 'status', title: 'Başvuru Durumu' },
                        {
                            dataIndex: 'tahsisSonuc',
                            title: 'Tahsis Sonuç',
                            render: function (c) { return _.get(_.find(stores.constant.model, { id: c }), 'name'); }
                        }
                    ];
                }
                if (stores.auth.hasRole('administrator') || stores.auth.hasRole('yetkili') || stores.auth.hasRole('değerlendirici')) {
                    this.columns = [
                        { dataIndex: 'email', title: 'Email' },
                        { dataIndex: 'basvuruNo', title: 'Başvuru No' },
                        { dataIndex: 'name', title: 'Firma Adı' },
                        {
                            dataIndex: 'yatiriminSektoruVeKonusu',
                            title: 'Sektör',
                            render: function (c) { return _.get(_.find(stores.constant.model, { id: c }), 'name'); }
                        },
                        { dataIndex: 'createdOn', title: 'İlk Başvuru Tarihi', render: function (c) { return c.format('DD.MM.YYYY'); } },
                        { dataIndex: 'basvuruTarihi', title: 'Son Güncelleme Tarihi', render: function (c) { return c ? c.format('DD.MM.YYYY') : ''; } },
                        { dataIndex: 'status', title: 'Başvuru Durumu' },
                        { dataIndex: 'basariPuani', title: 'Başvuru Puanı' },
                        { dataIndex: 'basariSirasi', title: 'Başvuru Sıralaması' },
                        {
                            dataIndex: 'basvuruSonuc',
                            title: 'Başvuru Sonuç',
                            render: function (c) { return _.get(_.find(stores.constant.model, { id: c }), 'name'); }
                        },
                        {
                            dataIndex: 'tahsisSonuc',
                            title: 'Tahsis Sonuç',
                            render: function (c) { return _.get(_.find(stores.constant.model, { id: c }), 'name'); }
                        },
                        { dataIndex: 'nihaiRaporTarihi', title: 'Nihai Rapor Tarihi', render: function (c) { return c && c.format('DD.MM.YYYY'); } }
                    ];
                }
                this.columns.push({ dataIndex: 'actions', title: 'İşlem', render: menu });
                return [2 /*return*/];
            });
        });
    };
    default_1.prototype.delete = function (id) {
        var _this = this;
        Modal.confirm({
            title: 'Veriyi silmek istediğinizden emin misiniz?',
            onOk: function () {
                services.Company.delete(id).then(function () {
                    message.success('Veri silindi..');
                    _this.refresh();
                });
            }
        });
    };
    default_1.prototype.render = function () {
        var _this = this;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Page, { buttons: React.createElement(Fragment, null,
                (stores.auth.hasRole('administrator') || stores.auth.hasRole('osb yetkilisi')) && (React.createElement(Button, { type: "primary", onClick: function () { return (_this.modal.basvuru = true); } }, "Ba\u015Fvuru Linki G\u00F6nder")),
                React.createElement(Dropdown, { overlay: React.createElement(Menu, { onClick: function (e) {
                            var link = '/api/common/companyservice/excelWithCols';
                            if (e.key.indexOf('Detay') > -1) {
                                link = '/api/common/companyservice/excel';
                            }
                            if (e.key.startsWith('secili')) {
                                link += '?' + _this.selected.map(function (c) { return 'id=' + c.id; }).join('&');
                            }
                            window.open(location.origin + link);
                        } },
                        React.createElement(Menu.Item, { key: "secili", disabled: !this.selected.length }, "Se\u00E7ilileri \u0130ndir"),
                        React.createElement(Menu.Item, { key: "tumu" }, "T\u00FCm\u00FCn\u00FC \u0130ndir"),
                        (stores.auth.hasRole('administrator') || stores.auth.hasRole('yetkili')) && (React.createElement(Menu.Item, { key: "seciliDetay", disabled: !this.selected.length }, "Se\u00E7ilileri \u0130ndir (Detayl\u0131)")),
                        (stores.auth.hasRole('administrator') || stores.auth.hasRole('yetkili')) && (React.createElement(Menu.Item, { key: "tumuDetay" }, "T\u00FCm\u00FCn\u00FC \u0130ndir (Detayl\u0131)"))) },
                    React.createElement(Button, null,
                        "Listeyi \u0130ndir ",
                        React.createElement(Icon, { type: "down" }))),
                (stores.auth.hasRole('administrator') || stores.auth.hasRole('yetkili')) && (React.createElement(Dropdown, { overlay: React.createElement(Menu, { onClick: function (e) {
                            var link = '/api/common/companyservice/DownloadRapor';
                            if (e.key === 'secili') {
                                link += '?' + _this.selected.map(function (c) { return 'id=' + c.id; }).join('&');
                            }
                            window.open(link);
                        } },
                        React.createElement(Menu.Item, { key: "secili", disabled: !this.selected.length }, "Se\u00E7ilileri \u0130ndir"),
                        React.createElement(Menu.Item, { key: "tumu" }, "T\u00FCm\u00FCn\u00FC \u0130ndir")) },
                    React.createElement(Button, null,
                        "Nihai Rapor ",
                        React.createElement(Icon, { type: "down" })))),
                (stores.auth.hasRole('administrator') || stores.auth.hasRole('yetkili')) && (React.createElement(Button, { style: { marginLeft: '10px' }, onClick: function () { return history.push('/common/company/list/inactive'); } }, "Pasif Ba\u015Fvurular")),
                React.createElement(Button, { icon: "reload", style: { marginLeft: '10px' }, onClick: this.refresh }, "Yenile"),
                React.createElement(Dropdown, { disabled: !this.selected.length, overlay: React.createElement(Menu, { onClick: function (e) {
                            var mustBe = e.key === 'Başvuru Onaylandı' ? 'Başvuru Tamamlandı' : 'Başvuru Onaylandı';
                            var promises = _this.selected.filter(function (c) { return c.status === mustBe; }).map(function (c) { return services.Company.setStatus(c.id, e.key); });
                            _this.loading = true;
                            Promise.all(promises)
                                .then(function () {
                                message.success(promises.length +
                                    ' ' +
                                    (e.key === 'Başvuru Onaylandı' ? 'Başvuru Onaylandı' : 'Başvuru Değerlendirmeye Gönderildi'));
                                _this.refresh();
                            })
                                .catch(function () {
                                _this.loading = false;
                            });
                        } },
                        (stores.auth.hasRole('administrator') || stores.auth.hasRole('osb yetkilisi')) && (React.createElement(Menu.Item, { key: "De\u011Ferlendirmede" }, "De\u011Ferlendirmeye G\u00F6nder")),
                        (stores.auth.hasRole('administrator') || stores.auth.hasRole('osb yetkilisi')) && (React.createElement(Menu.Item, { key: "Ba\u015Fvuru Onayland\u0131" }, "Ba\u015Fvuruyu Onayla"))) },
                    React.createElement(Button, null,
                        this.selected.length,
                        " Se\u00E7ili ",
                        React.createElement(Icon, { type: "down" })))), title: "Ba\u015Fvurular", loading: this.loading },
            React.createElement("div", { className: "card-header" },
                React.createElement("h5", { className: "card-title" }, "Ba\u015Fvuru Listesi")),
            React.createElement("div", { className: "card-body" },
                React.createElement(Form, { layout: "inline", style: { padding: '0px 0px 20px 30px' } },
                    React.createElement(Form.Item, null,
                        React.createElement(Input, { style: { width: 200 }, placeholder: "Firma Ad\u0131, Ba\u015Fvuru No Arama..", onChange: function (c) { return (_this.filter = c.target.value); } })),
                    React.createElement(Form.Item, null, getFieldDecorator('status')(React.createElement(Select, { style: { width: 200 }, placeholder: "Ba\u015Fvuru durumu" },
                        React.createElement(Select.Option, { value: "Ba\u015Fvuru Onayland\u0131" }, "Ba\u015Fvuru Onayland\u0131"),
                        React.createElement(Select.Option, { value: "De\u011Ferlendirmede" }, "De\u011Ferlendirmede"),
                        React.createElement(Select.Option, { value: "Link G\u00F6nderildi" }, "Link G\u00F6nderildi"),
                        React.createElement(Select.Option, { value: "Nihai Rapor" }, "Nihai Rapor"),
                        React.createElement(Select.Option, { value: "Ba\u015Fvuru Tamamland\u0131" }, "Tamamland\u0131")))),
                    (stores.auth.hasRole('administrator') || stores.auth.hasRole('yetkili') || stores.auth.hasRole('değerlendirici')) && (React.createElement("span", null,
                        React.createElement(Form.Item, null, getFieldDecorator('basvuruSonuc')(React.createElement(ConstantField, { group: "firma.basvuru.sonuc", style: { width: 200 }, placeholder: "Ba\u015Fvuru Sonucu" }))),
                        React.createElement(Form.Item, null, getFieldDecorator('tahsisSonuc')(React.createElement(ConstantField, { group: "firma.basvuru.tahsis", style: { width: 200 }, placeholder: "Tahsis Sonucu" }))),
                        React.createElement(Form.Item, null, getFieldDecorator('yatiriminSektoruVeKonusu')(React.createElement(ConstantField, { group: "firma.yatirim.sektor", style: { width: 200 }, placeholder: "Sekt\u00F6r" }))))),
                    React.createElement(Form.Item, null,
                        React.createElement(Button, { type: "primary", onClick: function () {
                                _this.props.form.validateFields(function (err, values) {
                                    _this.filters = Object.keys(values)
                                        .map(function (val) {
                                        return (values[val] !== undefined && {
                                            property: val,
                                            operator: '==',
                                            value: values[val]
                                        });
                                    })
                                        .filter(Boolean);
                                    _this.refresh();
                                });
                            } }, "Filtrele")),
                    React.createElement(Form.Item, null,
                        React.createElement(Button, { onClick: function () {
                                _this.props.form.resetFields();
                                _this.filter = '';
                                _this.filters = [];
                                _this.refresh();
                            } }, "Temizle"))),
                React.createElement(Table, { columns: this.columns, dataSource: this.model.filter(function (c) {
                        var ff = _this.filter.toLocaleLowerCase().trim();
                        return (c.name && c.name.toLocaleLowerCase().indexOf(ff) > -1) || (c.basvuruNo && c.basvuruNo.toLocaleLowerCase().indexOf(ff)) > -1;
                    }), pagination: {
                        showSizeChanger: true,
                        defaultPageSize: Number(localStorage.getItem('pagination_size')) || 10,
                        onShowSizeChange: function (current, size) {
                            localStorage.setItem('pagination_size', size.toString());
                        }
                    }, size: "small", rowKey: "id", rowSelection: {
                        onChange: function (_, rows) {
                            _this.selected = rows;
                        }
                    } })),
            React.createElement(Modal, { visible: this.modal.basvuru, onOk: this.onBasvuru, okText: "G\u00F6nder", onCancel: function () {
                    _this.modal.basvuru = false;
                    _this.modal.basvuruLink = '';
                } },
                React.createElement(Spin, { spinning: this.modal.loading },
                    React.createElement(Form, null,
                        React.createElement(Form.Item, { label: "Email" }, this.props.form.getFieldDecorator('email', {
                            rules: [
                                { type: 'email', message: 'Alan geçerli bir email adresi değil!' },
                                { required: true, message: 'Alan gerekli!' }
                            ]
                        })(React.createElement(Input, { disabled: !!this.modal.basvuruLink }))))))));
    };
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        observable
    ], default_1.prototype, "model", void 0);
    __decorate([
        observable
    ], default_1.prototype, "selected", void 0);
    __decorate([
        observable
    ], default_1.prototype, "modal", void 0);
    __decorate([
        observable
    ], default_1.prototype, "columns", void 0);
    __decorate([
        observable
    ], default_1.prototype, "filters", void 0);
    __decorate([
        observable
    ], default_1.prototype, "filter", void 0);
    default_1 = __decorate([
        form,
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/common/company/List.tsx
// module id = 1264
// module chunks = 0